var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_job_posting_response",
          attrs: {
            id: "modal-job-posting-response",
            title: _vm.title,
            size: "lg",
            "modal-class": "custom-modal",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end py-2" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1",
                          class: !_vm.newItem.fits
                            ? "custom-btn-primary"
                            : "custom-btn-danger",
                          attrs: { disabled: _vm.loading },
                          on: {
                            click: function($event) {
                              return _vm.toggleFit()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: {
                              icon: !_vm.newItem.fits ? "check" : "times"
                            }
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                !_vm.newItem.fits ? "Подходит" : "Не подходит"
                              ) +
                              "\n        "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary ml-auto mr-2",
                          on: { click: _vm.handleCancel }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { disabled: _vm.loading },
                          on: { click: _vm.handleOk }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v("\n          Сохранить\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-card",
                          { attrs: { "bg-variant": "light" } },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mt-2 mb-2",
                                    attrs: { cols: "lg" }
                                  },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "13%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mb-2" },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "5%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mb-2" },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "16%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mb-2" },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "13%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mb-2" },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "6%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mb-2" },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "8%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mb-2" },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "6%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "13%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-card",
                          { staticClass: "custom-card" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-job-posting-select",
                                  label: "Объявление"
                                }
                              },
                              [
                                _c("recruit-job-posting-select", {
                                  ref: "job_posting_select",
                                  attrs: {
                                    "is-disabled": _vm.isDisabled,
                                    value: _vm.newItem.job_posting_id,
                                    state: _vm.getFieldState("job_posting_id")
                                  },
                                  on: { onSelect: _vm.onJobPostingSelect }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: { id: "group-location", label: "Объект" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    value: _vm.newItem.location_name,
                                    disabled: ""
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              { attrs: { id: "group-name", label: "ФИО" } },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    placeholder: "Введите ФИО",
                                    disabled: _vm.isDisabled,
                                    state: _vm.getFieldState("name")
                                  },
                                  model: {
                                    value: _vm.newItem.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "name", $$v)
                                    },
                                    expression: "newItem.name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-birth-date",
                                  label: "Дата рождения"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "date",
                                    disabled: _vm.isDisabled
                                  },
                                  model: {
                                    value: _vm.newItem.birth_date,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "birth_date", $$v)
                                    },
                                    expression: "newItem.birth_date"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-citizenship",
                                  label: "Гражданство"
                                }
                              },
                              [
                                _c("citizenship-select", {
                                  attrs: {
                                    id: "input-citizenship-select",
                                    "is-disabled": _vm.isDisabled,
                                    value: _vm.newItem.citizenship_id
                                  },
                                  on: { onSelect: _vm.onSelectCitizenship }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              { attrs: { id: "group-town", label: "Город" } },
                              [
                                _c("town-select", {
                                  attrs: {
                                    value: _vm.newItem.town_id,
                                    "is-disabled": _vm.isDisabled
                                  },
                                  on: { onSelect: _vm.onSelectTown }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: { id: "group-phone", label: "Контакт" }
                              },
                              [
                                _c(
                                  "b-input-group",
                                  {
                                    attrs: {
                                      size: "sm",
                                      prepend: _vm.phoneInputPrefix(
                                        _vm.newItem.phone
                                      )
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "tel",
                                        disabled: _vm.isDisabled,
                                        placeholder: _vm.$t(
                                          "message.workers.modal.phonePlaceholder"
                                        ),
                                        state: _vm.phoneState
                                      },
                                      model: {
                                        value: _vm.newItem.phone,
                                        callback: function($$v) {
                                          _vm.$set(_vm.newItem, "phone", $$v)
                                        },
                                        expression: "newItem.phone"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-invalid-feedback",
                                      { attrs: { state: _vm.phoneState } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.phoneInvalidFeedback) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              { attrs: { id: "group-email", label: "Почта" } },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.isDisabled,
                                    placeholder: "Введите почту"
                                  },
                                  model: {
                                    value: _vm.newItem.email,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "email", $$v)
                                    },
                                    expression: "newItem.email"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: { id: "group-status", label: "Статус" }
                              },
                              [
                                _c("recruit-response-status-select", {
                                  attrs: {
                                    "is-disabled": _vm.isDisabled,
                                    state: _vm.getFieldState("status_id"),
                                    value: _vm.newItem.status_id,
                                    "drop-up": ""
                                  },
                                  on: {
                                    onSelect: _vm.onSelectRecruitResponseStatus
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-response-date",
                                  label: "Дата отклика"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "date",
                                    disabled: _vm.isDisabled
                                  },
                                  model: {
                                    value: _vm.newItem.start_date,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "start_date", $$v)
                                    },
                                    expression: "newItem.start_date"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0d3485e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0d3485e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/JobPostingResponse.vue
// module id = null
// module chunks = 